import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [
  {
    title: 'Reportes',
    path: '/reportes/estado_de_cuenta',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
];

const ReporteEstadoCuentaPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Estado de Cuenta</PageTitle>
      <View />
    </>
  );
};

export { ReporteEstadoCuentaPage };
